import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../AuthModule';
import AvatarWithDesignerBadge from './AvatarWithDesignerBadge';
import { API, AvatarFallback } from './profileHelpers';
import ProfileNavTopBar from '../ProfileNavTopBar';
import { useT } from '../../i18n/I18nModule';
import { loadingPageText } from '../../i18n/loadingPage';

export default function AdminUsersPage() {
  const { user } = useAuth();
  const t = useT();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);

  const userIdStr = user?.id != null ? String(user.id).replace(/n$/, '') : '';

  const load = useCallback(() => {
    if (!userIdStr) return;
    setLoading(true);
    setError(null);
    fetch(`${API}/api/admin/users/list?userId=${encodeURIComponent(userIdStr)}`)
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.error || 'Käyttäjien lataus epäonnistui.');
        return data;
      })
      .then((data) => {
        setUsers(Array.isArray(data?.users) ? data.users : []);
      })
      .catch((e) => {
        setUsers([]);
        setError(e.message || 'Käyttäjien lataus epäonnistui.');
      })
      .finally(() => setLoading(false));
  }, [userIdStr]);

  useEffect(() => {
    if (!userIdStr) return;
    load();
  }, [userIdStr, load]);

  if (!user) {
    return (
      <div className="App-block">
        <p>Kirjaudu sisään nähdäksesi käyttäjät.</p>
      </div>
    );
  }

  if (user.role !== 'admin') {
    return (
      <div className="App-block">
        <p>Tämä sivu on vain ylläpitäjille.</p>
      </div>
    );
  }

  return (
    <div className="App-block Friends-page">
      <div className="kaverit-container">
        <ProfileNavTopBar user={user} currentPage="users" />
        {loading ? (
          <p>{loadingPageText(t, 'users')}</p>
        ) : error ? (
          <p className="Inbox-error" role="alert">
            {error}
          </p>
        ) : (
          <section className="Friends-section Friends-section--approved" aria-labelledby="admin-users-heading">
            <h3 id="admin-users-heading" className="Friends-kaverit-heading">
              KÄYTTÄJÄT
            </h3>
            {users.length === 0 ? (
              <p className="Friends-empty">Ei käyttäjiä.</p>
            ) : (
              <ul className="Friends-list Friends-list--cards">
                {users.map((row) => {
                  const profileHref = `/profiili/${encodeURIComponent(row.displayName)}`;
                  return (
                    <li key={row.userId} className="Friends-card">
                      <a className="Friends-card-surface Friends-card-main" href={profileHref}>
                        <span className="Friends-card-avatar Friends-card-avatar-wrap" aria-hidden="true">
                          <AvatarWithDesignerBadge designer={row.avatarDesigner} variant="forum">
                            {row.avatarUrl ? (
                              <img src={row.avatarUrl} alt="" className="Friends-card-avatar-img" />
                            ) : (
                              <AvatarFallback
                                displayName={row.displayName}
                                username={row.username}
                                size="small"
                                bubbleColorHex={row.bubbleColor}
                              />
                            )}
                          </AvatarWithDesignerBadge>
                        </span>
                        <span className="Friends-card-body">
                          <span className="Friends-card-name">{row.displayName}</span>
                          <span className="Friends-card-meta">@{row.username}</span>
                        </span>
                      </a>
                    </li>
                  );
                })}
              </ul>
            )}
          </section>
        )}
      </div>
    </div>
  );
}
